// components/Container.tsx
import { mergeProps } from "solid-js";
import { Box, type BoxProps } from "styled-system/jsx";

export default function Panel(props: BoxProps) {
  // mergeProps ensures the incoming props override the defaults if there's a conflict
  const mergedProps = mergeProps(
    { p: '3', className: 'scrollbar' },
    props
  );

  return <Box bg={props.bg || 'bg.emphasized'} {...mergedProps} />;
}
